import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import styles from "./LegalText.module.scss";

const { sanitize } = dompurify;

type LegalIntroductionProps = {
  legalText?: string;
  className?: string;
};

export const LegalText = ({ legalText, className }: LegalIntroductionProps) => {
  if (!legalText) {
    return null;
  }

  return (
    <div
      dangerouslySetInnerHTML={{ __html: sanitize(legalText, { ADD_ATTR: ["target"] }) }}
      className={classNames(styles.legalText, className)}
    />
  );
};
